import { ExternalUrlItem, ExternalUrlValue } from 'app/area/external-url-groups/form/types-store';

export const createExternalUrlSelectedValues = (externalUrls: ExternalUrlItem[] = []): ExternalUrlValue[] =>
  externalUrls.map(url => ({
    value: url.code.value,
    description: url.code.description,
    longDescription: url.code?.longDescription,
    disabled: url?.disabled,
    urlTemplate: url?.urlTemplate
  }));
